<template>
  <v-alert dismissible type="error" v-if="Object.entries(errors).length > 0">
    <ul>
      <li v-for="(error, index) in Object.entries(errors)" :key="index">
        {{ error[0] }}: {{ error[1] }}
      </li>
    </ul>
  </v-alert>
</template>

<script>
export default {
  name: "Errors",
  props: {
    errors: Object
  }
};
</script>
